module.exports = __webpack_public_path__ + "img/pc-backdrop.63b912ef.webp";